import { infoCard } from "./infoCard.js";
import { plans } from "./plansData.js";

export const priceCalculator = () => {
    const calcForm = document.querySelector('#plans-prices #calculator');
    const mainContainer = document.querySelector('#plans-prices .main-content__tabs');
    const totalSpan = document.querySelector('#plans-prices .tabs__total-price');
    const planFeeElem = document.querySelector('#plans-prices .calc__param-fee-value');

    const getRefOrdersQty = (fees) => {
        if (!fees) return null
        const ordersList = Object.keys(fees).map(range => range.split('-').at(-1)).filter(num => num != Infinity);
        const res = ordersList.map((num, i, arr) => {
            if (arr[i - 1]) {
                return num = +num - arr[i - 1]
            } else {
                return +num;
            }
        })
        return res;
    }

    const calculateTotal = (orders, cost, selectedPlan) => {
        if (selectedPlan === 'enterprise') return {total: 0, extra: null};
        const refQty = getRefOrdersQty(plans[selectedPlan].fees);
        const extra = selectedPlan == 'business' ? 50 : 0;
        let total = 0;
        let ordersBreakdown = [];
        let ordersCount = orders;
        for (const ref of refQty) {
            if (ordersCount >= ref) {
                ordersBreakdown.push(ref);
                ordersCount -= ref;
                if (refQty.indexOf(ref) === refQty.length - 1 && ordersCount > 0) {
                    ordersBreakdown.push(ordersCount)
                    break
                }
            } else if (ordersCount > 0) {
                ordersBreakdown.push(ordersCount);
                break
            }
        }

        ordersBreakdown.forEach((group, i) => {
            const percentage = Object.values(plans[selectedPlan].fees).toSorted((a, b) => b - a);
            if (percentage.includes(0)) {
                percentage.pop()
                percentage.unshift(0);
            }
            const coefficient = percentage[i];
            total += (group * cost) * coefficient;
        })

        total += extra;

        return {total, extra};
    } 

    const calculate = () => {
        const selectedPlan = mainContainer.dataset.selectedTab;

        const data = {};

        const formData = new FormData(calcForm);
        for (const pair of formData.entries()) {
            data[pair[0]] = +pair[1] ? +pair[1] : 0;
        };

        let {total, extra} = calculateTotal(data['orders-monthly'], data['average-cost'], selectedPlan);

        if (total > 3000) total = 3000;
        totalSpan.textContent = total.toFixed(2) + ' $';

        planFeeElem.textContent = extra;
        infoCard.updatePlanPrice(extra);
        if (selectedPlan == 'enterprise') infoCard.updatePlanPrice('?')
    }

    calcForm.addEventListener('change', calculate);
    calcForm.addEventListener('paste', () => {
        calculate();
    });
    calcForm.addEventListener('input', () => {
        calculate();
    });
    mainContainer.addEventListener('tab-change', calculate);
    document.dispatchEvent(new CustomEvent('price-calculated'));
    if (!window.priceCalculator) window.priceCalculator = {};
    window.priceCalculator.calculate = calculate.bind(this);
}